import { PeriodTypes } from '../../lib/types/models/period/period'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updatePeriod(data: UpdateInput<PeriodTypes.Input>) {
  const { id, ...rest } = data
  return restApiClient.url(constructApiUrl(API.periods.update.url, { id })).patch(rest)
}
